import api from './api';

export const estimateService = {
  getAll: (params = {}) => api.get('/estimates/', { params }),
  getById: (id) => api.get(`/estimates/${id}`),
  create: (data) => api.post('/estimates/', data),
  update: (id, data) => api.put(`/estimates/${id}`, data),
  updateStatus: (id, status, notes) => api.put(`/estimates/${id}/status`, { status, notes }),
  delete: (id) => api.delete(`/estimates/${id}`),
  send: (id) => api.post(`/estimates/${id}/send`),
  generatePDF: (id) => api.get(`/estimates/${id}/pdf`),
};
